import BotonAyudaManuales from "../../../Components/BotonAyudaManuales";
import {
  CheckCircleOutlined,
  CopyOutlined,
  EditOutlined,
  EyeOutlined,
  StopOutlined,
  ApartmentOutlined,
  ToolOutlined,
  ImportOutlined,
} from "@ant-design/icons";
import { PageHeader, Popconfirm, message, Tooltip, Tag } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { TableItemDinamico, ButtonItem, SegmentedItem, dineroDisabledMask } from "../../../Components/Items";
import HeaderActions from "../../../Components/HeaderActions";
import DuplicarMatriz from "./DuplicarMatriz/DuplicarMatriz";
import { tipoMatrizInfo } from "./matriz.utils";
import { formatearTiempoCiclo } from "../PresupuestosPU/OrdenesDeProduccionPU/PlaneacionProduccionPU/planeacion.utils";

class Matrices extends Component {
  tableRef = null;
  state = {
    idEditarInsumoCompuesto: null,
    todasMatrices: [],
    loading: false,
    valor: 1,
    totalRecords: 0,
  };
  consultarMatrices(params) {
    this.setState({ loading: true })
    axios
      .post(
        "matrices/selectTodasMatrices",
        { empresaId: this.props.empresaId, ...params },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false })
        if (res.data.success !== 2) {
          this.setState({ todasMatrices: [] });
        } else {
          this.setState({
            todasMatrices: res.data.data,
            totalRecords: res.data.totalRecords || 0,
          });
        }
      });
  }
  refrescarMatrices() {
    if (this.tableRef) {
      this.tableRef.updateExternalFilters({ valor: this.state.valor });
    }
  }
  deshabilitarMatriz(value) {
    axios
      .post(
        "matrices/deshabilitarMatriz",
        { insumoId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Matriz deshabilitado");
        } else {
          message.error("Sucedio un eror y no se pudo deshabilitar");
        }
        this.refrescarMatrices();
      });
  }
  habilitarMatriz(value) {
    axios
      .post(
        "matrices/habilitarMatriz",
        { insumoId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Matriz habilitado");
        } else {
          message.error("Sucedio un eror y no se pudo habilitar");
        }
        this.refrescarMatrices();
      });
  }
  abrirProduccion(id) {
    this.props.history.push("/panel/editarMatriz", { id, tabProduccion: true });
  }
  crearOrdenDeProduccion(record) {
    this.props.history.push("/panel/ordenDeProduccionPU", { matrizId: record._id });
  }
  agregarMatriz() {
    this.props.history.push("/panel/agregarMatriz");
  }
  editarMatriz(id) {
    this.props.history.push("/panel/editarMatriz", { id });
  }

  actualizarCostos() {
    this.setState({ loading: true })
    axios
      .post(
        "matrices/actualizarCostos",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.refrescarMatrices();
        } else {
          message.warning('No se pudo actualizar los costos')
          this.setState({ loading: false })
        }
      });
  }

  verificarMatrices() {
    this.setState({ loading: true })
    axios
      .post(
        "matrices/verificarMatrices",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.success === 2) {
          if (res.data.cantidadMalas > 0) {
            message.warning(`Se encontraron ${res.data.cantidadMalas} matrices con problemas`);
          }
          this.refrescarMatrices();
        } else {
          message.warning('No se pudo verificar las matrices')
          this.setState({ loading: false })
        }
      });
  }

  importarMatrices() {
    this.props.history.push("/panel/importarMatrices");
  }

  duplicarMatriz(id) {
    this.setState({ modalDuplicar: true, modalDuplicarId: id })
  }

  cerrarDuplicarMatriz() {
    this.setState({ modalDuplicar: false, modalDuplicarId: null })
    this.refrescarMatrices()
  }

  render() {
    const columns = [
      {
        title: "Codigo",
        dataIndex: "codigo",
        key: "codigo",
        defaultSortOrder: 'ascend',
        sorter: (a, b) => {
          if (a.codigo < b.codigo) {
            return -1;
          }
          if (a.codigo > b.codigo) {
            return 1;
          }
          return 0;
        },
        buscar: "codigo",
        width: "8%",
      },
      {
        title: "Clave",
        dataIndex: "clave",
        key: "clave",
        sorter: true,
        buscar: "clave",
        width: "8%",
      },
      {
        title: "Descripción",
        dataIndex: "descripcion",
        key: "descripcion",
        sorter: true,
        buscar: "descripcion",
        width: "34%",
      },
      {
        title: "Costo",
        dataIndex: "costo",
        key: "costo",
        sorter: true,
        render: (value) => dineroDisabledMask(value || 0),
        width: "10%",
        align: 'right'
      },
      {
        title: "Costo Max.",
        dataIndex: "costoMaximo",
        key: "costoMaximo",
        sorter: true,
        render: (value) => dineroDisabledMask(value || 0),
        width: "10%",
        align: 'right'
      },
      {
        title: "Costo Prom.",
        dataIndex: "costoPromedio",
        key: "costoPromedio",
        sorter: true,
        render: (value) => dineroDisabledMask(value || 0),
        width: "10%",
        align: 'right'
      },
      {
        title: "Costo Min.",
        dataIndex: "costoMinimo",
        key: "costoMinimo",
        sorter: true,
        render: (value) => dineroDisabledMask(value || 0),
        width: "10%",
        align: 'right'
      },
      {
        title: "Flujo",
        dataIndex: "flujo",
        key: "flujo",
        width: "10%",
        render: (value) => value || "",
      },
      {
        title: "T. ciclo",
        dataIndex: "tiempoCicloTotal",
        key: "tiempoCicloTotal",
        sorter: true,
        width: "8%",
        align: 'right',
        render: (value) => (
          <Tooltip title="Suma de los tiempos ciclo de todas las etapas, por pieza" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
            <span style={{ color: value > 0 ? undefined : '#bfbfbf' }}>{formatearTiempoCiclo(value || 0, this.props.unidadTiempoProduccion)}</span>
          </Tooltip>
        ),
      },
      {
        title: "Unidad",
        dataIndex: "unidad",
        key: "unidad",
        buscar: "unidad",
        width: "8%",
      },
      {
        title: "Familia",
        dataIndex: "familia",
        key: "familia",
        buscar: "familia",
        width: "18%",
      },
      {
        title: "Versión",
        dataIndex: "versionNumero",
        key: "versionNumero",
        width: "7%",
        align: "center",
        render: (versionNumero) => "v" + (versionNumero || 1),
      },
      {
        title: "Tipo",
        dataIndex: "tipoMatriz",
        key: "tipoMatriz",
        width: "8%",
        align: "center",
        render: (tipoMatriz) => {
          const info = tipoMatrizInfo(tipoMatriz);
          if (!info) return null;
          return (
            <Tooltip title={info.descripcion} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <Tag color={info.color}>{info.label}</Tag>
            </Tooltip>
          );
        },
      },
      {
        title: "Autorización",
        dataIndex: "autorizado",
        key: "autorizado",
        width: "10%",
        align: "center",
        render: (autorizado, record) => (
          record.superado
            ? <Tag color="default">Superada</Tag>
            : autorizado
              ? <Tag color="green">Autorizada</Tag>
              : <Tag color="orange">Borrador</Tag>
        ),
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        align: "center",
        width: "15%",
        onHeaderCell: () => ({
          style: { textAlign: 'center', padding: '4px' }
        }),
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: 'center', padding: '4px' }
        }),
        render: (value, record) => {
          let buttons = [];

          if (this.props.permisoEditarMatriz) {
            buttons.push(
              <Tooltip title={record.superado ? "Ver Matriz (versión superada, solo lectura)" : "Editar Matriz"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  key={`editar-${record._id}`}
                  type="default"
                  size="small"
                  cyan
                  icon={record.superado ? <EyeOutlined /> : <EditOutlined />}
                  onClick={() => this.editarMatriz(record._id)}
                >
                </ButtonItem>
              </Tooltip>
            );
          }

          if (this.props.permisoDeshabilitarMatriz) {
            if (record.estado === 1) {
              buttons.push(
                <Popconfirm
                  key={`deshabilitar-${record._id}`}
                  title="Seguro que quieres deshabilitar esta matriz"
                  onConfirm={() => this.deshabilitarMatriz(record._id)}
                  okText="Si"
                  cancelText="No"
                >
                  <Tooltip title="Deshabilitar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                    <ButtonItem
                      type="default"
                      size="small"
                      lima
                      icon={<CheckCircleOutlined />}
                    >
                    </ButtonItem>
                  </Tooltip>
                </Popconfirm>
              );
            } else {
              buttons.push(
                <Popconfirm
                  key={`habilitar-${record._id}`}
                  title="Seguro que quieres habilitar esta matriz"
                  onConfirm={() => this.habilitarMatriz(record._id)}
                  okText="Si"
                  cancelText="No"
                >
                  <Tooltip title="Habilitar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                    <ButtonItem
                      type="default"
                      size="small"
                      rojo
                      icon={<StopOutlined />}
                    >
                    </ButtonItem>
                  </Tooltip>
                </Popconfirm>
              );
            }
          }
          if (this.props.permisoEditarMatriz && record.tipoMatriz !== 1) {
            buttons.push(
              <Tooltip title="Flujo y producción de la matriz" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  key={`produccion-${record._id}`}
                  type="default"
                  size="small"
                  lila
                  icon={<ApartmentOutlined />}
                  onClick={() => this.abrirProduccion(record._id)}
                >
                </ButtonItem>
              </Tooltip>
            );
          }
          if (this.props.permisoAgregarOrdenProduccionPU && record.estado === 1 && record.autorizado && !record.superado && record.tipoMatriz !== 1 && record.flujoProduccionPUId) {
            buttons.push(
              <Tooltip title="Crear orden de producción" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  key={`orden-${record._id}`}
                  type="default"
                  size="small"
                  verde
                  icon={<ToolOutlined />}
                  onClick={() => this.crearOrdenDeProduccion(record)}
                >
                </ButtonItem>
              </Tooltip>
            );
          }
          buttons.push(
            <Tooltip title="Duplicar Matriz" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem
                key={`duplicar-${record._id}`}
                type="default"
                size="small"
                blanco
                icon={<CopyOutlined />}
                onClick={() => this.duplicarMatriz(record._id)}
              >
              </ButtonItem>
            </Tooltip>
          );

          return <div className="acciones-container">{buttons}</div>;
        },
      },
    ];
    return (
      <>
        <PageHeader
          title="Matrices"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              {this.props.permisoAgregarInsumoCompuesto && <>

              {window.innerWidth > 1000 &&
                <SegmentedItem
                  options={[{ label: 'Activo', value: 1 }, { label: 'Deshabilitado', value: 2 }, { label: 'Todos', value: 3 }, { label: 'Pendientes de autorización', value: 4 }]}
                  onChange={(value) => {
                    if (this.tableRef) {
                      this.tableRef.updateExternalFilters({ valor: value });
                    }
                    this.setState({ valor: value })
                  }}
                  value={this.state.valor}
                />
              }
              <HeaderActions>
                <Popconfirm
                  title={
                    "Seguro que quieres actualizar todos los costos"
                  }
                  onConfirm={this.actualizarCostos.bind(this)}
                  okText="Si"
                  cancelText="No"
                >
                  {this.props.permisoActualizarCostos &&
                    <ButtonItem
                      key="actualizarCostos"
                      blanco
                    >
                      Actualizar Costos
                    </ButtonItem>}
                </Popconfirm>
                <Popconfirm
                  title={
                    "Verificar que las matrices esten bien?"
                  }
                  onConfirm={this.verificarMatrices.bind(this)}
                  okText="Si"
                  cancelText="No"
                >
                  {this.props.permisoActualizarCostos &&
                    <ButtonItem
                      key="actualizarCostos"
                      verde
                    >
                      Verificar
                    </ButtonItem>}
                </Popconfirm>
                {this.props.permisoAgregarMatriz &&
                  <ButtonItem
                    key="importarMatrices"
                    type="default"
                    icon={<ImportOutlined />}
                    onClick={this.importarMatrices.bind(this)}
                  >
                    Importar Matriz
                  </ButtonItem>}
              </HeaderActions>

              {this.props.permisoAgregarMatriz &&
                <ButtonItem
                  type="primary"
                  key="agregarMatriz"
                  olivo
                  onClick={this.agregarMatriz.bind(this)}
                   className="botonAgregar"
                >
                  Agregar Matriz
                </ButtonItem>}
              </>}
              <BotonAyudaManuales modulo="matrices" />
            </div>
          }
        />
        <TableItemDinamico
          ref={(ref) => (this.tableRef = ref)}
          onRef={(ref) => (this.tableRef = ref)}
          totalRecords={this.state.totalRecords}
          loading={this.state.loading}
          size="small"
          onFetchData={this.consultarMatrices.bind(this)}
          anadirValorFiltro={this.state.valor}
          dataSource={this.state.todasMatrices}
          columns={columns}
          filterStorageKey={"matrices" + this.props.empresaId}
          onRow={(record) => ({
            onDoubleClick: () => this.editarMatriz(record._id),
          })}
          setValor={(valor) => this.setState({ valor })}
          valorDefault={1}
        />
        <DuplicarMatriz
          visible={this.state.modalDuplicar}
          id={this.state.modalDuplicarId}
          cerrarDuplicarMatriz={this.cerrarDuplicarMatriz.bind(this)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    unidadTiempoProduccion: state.empresa.unidadTiempoProduccion,
    permisoAgregarInsumoCompuesto: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6472d8d84b2da7c85c1a8d0b")?.activado,
    permisoEditarInsumoCompuesto: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6472d66d4b2da7c85c1a8d06")?.activado,
    permisoDeshabilitarInsumoCompuesto: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6472d69a4b2da7c85c1a8d07")?.activado,
    permisoActualizarCostos: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "675095b5798d4e0043687251")?.activado,
    permisoAgregarOrdenProduccionPU: state.user.tipo === 0 || !!state.user.permisos.find((v) => v.permisoId.toString() === "6a9b303352b97b73c85edc24")?.activado,
    permisoAgregarMatriz: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6750960a798d4e0043687252")?.activado,
    permisoEditarMatriz: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "67509631798d4e0043687253")?.activado,
    permisoDeshabilitarMatriz: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "67509647798d4e0043687254")?.activado,
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(Matrices);
